export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/calculateNodes.worker.19fed7d6.worker.js");
}
